import { ApiProperty } from "@nestjs/swagger";

export class VenndorIdReq{
    @ApiProperty()
    vendorId : number;
    @ApiProperty()
    poId?:number;
    @ApiProperty()
    poItemId?:number;
}